import React, { useState, useRef, useEffect } from 'react';
import {
  EllipsisVerticalIcon,
  DocumentArrowDownIcon,
  PencilSquareIcon,
  CalendarDaysIcon,
  CurrencyRupeeIcon,
} from '@heroicons/react/24/solid';
import { USER_ROLE } from '../../services/auth';

const DriverActionsMenu = ({ driver, onEdit, onDownload, onViewExpensesClick, onViewAttendanceClick }) => {
  const [open, setOpen] = useState(false);
  const menuRef = useRef();
  const role = localStorage.getItem(USER_ROLE);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <>
      {/* ✅ Desktop view: Edit + 3-dot dropdown */}
      <div className="hidden md:flex items-center gap-2 relative" ref={menuRef}>
        <button
          onClick={onEdit}
          className="p-1 rounded-full hover:bg-gray-100"
          title="Edit"
        >
          <PencilSquareIcon className="h-5 w-5 text-blue-600" />
        </button>
        <button
          onClick={() => onViewExpensesClick(driver)}
          className="p-1 rounded-full hover:bg-gray-100"
          title="View Expenses"
        >
          <CurrencyRupeeIcon className="h-5 w-5 text-green-700" />
        </button>
        { ['admin', 'branch_admin'].includes(role) &&
          <button
            onClick={() => onViewAttendanceClick(driver)}
            className="p-1 rounded-full hover:bg-gray-100"
            title="View Expenses"
          >
            <CalendarDaysIcon className="h-5 w-5 text-purple-700" />
          </button>
        }

        <div className="relative">
          <button
            onClick={() => setOpen(!open)}
            className="p-1 rounded-full hover:bg-gray-100"
            title="More"
          >
            <EllipsisVerticalIcon className="h-5 w-5 text-gray-700" />
          </button>

          {open && (
            <div className="absolute right-0 mt-2 w-44 bg-white border border-gray-200 rounded shadow-lg z-50">
              { driver.aadhar_doc != null && (
                <button
                  onClick={() => {
                    setOpen(false);
                    onDownload('aadhar');
                  }}
                  className="flex items-center px-4 py-2 w-full text-left text-sm hover:bg-gray-100"
                >
                  <DocumentArrowDownIcon className="w-4 h-4 mr-2 text-green-600" />
                    Aadhar
                </button>
              )}
              { driver.licence_doc != null && (
                <button
                  onClick={() => {
                    setOpen(false);
                    onDownload('licence');
                  }}
                  className="flex items-center px-4 py-2 w-full text-left text-sm hover:bg-gray-100"
                >
                  <DocumentArrowDownIcon className="w-4 h-4 mr-2 text-yellow-600" />
                  Licence
                </button>
              )}
              { driver.pan_doc != null && (
                <button
                  onClick={() => {
                    setOpen(false);
                    onDownload('pan');
                  }}
                  className="flex items-center px-4 py-2 w-full text-left text-sm hover:bg-gray-100"
                >
                  <DocumentArrowDownIcon className="w-4 h-4 mr-2 text-purple-600" />
                  PAN
                </button>
              )}
            </div>
          )}
        </div>
      </div>

      {/* ✅ Mobile View: Show all actions stacked directly */}
      <div className="md:hidden flex flex-col gap-1 mt-2">
        <button
          onClick={onEdit}
          className="flex items-center text-blue-600"
        >
          <PencilSquareIcon className="w-4 h-4 mr-1" />
          Edit
        </button>
        { driver.aadhar_doc != null && (
          <button
            onClick={() => onDownload('aadhar')}
            className="flex items-center text-green-600"
          >
            <img src="/icons/aadhar.png" alt="Aadhar" className="w-6 h-7 mr-1" />
            Aadhar
          </button>
        )}
        { driver.licence_doc != null && (
          <button
            onClick={() => onDownload('licence')}
            className="flex items-center text-purple-600"
          >
            <img src="/icons/driving.png" alt="Aadhar" className="w-6 h-7 mr-1" />
            Licence
          </button>
        )}
        { driver.pan_doc != null && (
          <button
            onClick={() => onDownload('pan')}
            className="flex items-center text-yellow-600"
          >
            <img src="/icons/pan.png" alt="Aadhar" className="w-6 h-7 mr-1" />
            PAN
          </button>
        )}
      </div>
    </>
  );
};

export default DriverActionsMenu;
